import Vue from 'vue'
import Router from 'vue-router'
import AboutPortal from '@/views/AboutPortal'
import NewsPortal from '@/views/NewsPortal'
import DeveloperPortal from '@/views/DeveloperPortal'
import HomePortal from '@/views/HomePortal'
import MinerPortal from '@/views/MinerPortal'
import PartnerPortal from '@/views/PartnerPortal'
import NCdnPortal from '@/views/NCdnPortal'
import NSwitchboard from '@/views/NPubSubPortal'
import DataRideSupport from '@/views/DataRideSupport'
import nknNamespace from '@/assets/js/nknNamespace'
import LogoDownload from '@/views/LogoDownload'
import WpDownload from '@/views/WpDownload'
import nMobile from '@/views/NMobileDownload'
import nMobilePro from '@/views/NMobileProDownload'

Vue.use(Router)
const langRoute = '/:lang(zh|kr|en)?'
const router = new Router({
  mode: "history",
  routes: [
    {
      path: langRoute + '/',
      name: nknNamespace.HOME,
      component: HomePortal
    },
    {
      path: langRoute + '/about/',
      name: nknNamespace.ABOUT,
      component: AboutPortal
    },
    {
      path: langRoute + '/news/',
      name: nknNamespace.NEWS,
      component: NewsPortal
    },
    {
      path: langRoute + '/developer/',
      name: nknNamespace.Developer,
      component: DeveloperPortal
    },
    {
      path: langRoute + '/miner/',
      name: nknNamespace.MINER,
      component: MinerPortal
    },
    {
      path: langRoute + '/partner/',
      name: nknNamespace.PARTNER,
      component: PartnerPortal
    },
    {
      path: langRoute + '/ncdn/',
      name: nknNamespace.NCdn,
      component: NCdnPortal
    },
    {
      path: langRoute + '/dataride/',
      name: nknNamespace.NSwitchboard,
      component: NSwitchboard
    },
    {
      path: langRoute + '/dataride/support/',
      name: 'dataride/support',
      component: DataRideSupport
    },
    {
      path: langRoute + '/logodownload/',
      name: 'logodownload',
      component: LogoDownload
    },
    {
      path: langRoute + '/WpDownload/',
      name: 'wpdownload',
      component: WpDownload
    },
    {
      path: langRoute + '/nMobile/',
      name: 'nMobile',
      component: nMobile
    },
    {
      path: langRoute + '/nMobile-pro/',
      name: 'nMobile-pro',
      component: nMobilePro
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js